import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { services } from '../mock/data';

const ServicesSection = () => {
  const serviceColors = {
    'Link IP Dedicado': 'bg-blue-500',
    'Telefonia IP': 'bg-purple-500',
    'Firewall Corporativo': 'bg-green-500',
    'PABX Virtual': 'bg-orange-500'
  };

  return (
    <section id="servicos" className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <span className="text-sm font-semibold tracking-wider uppercase text-[#0079be] mb-2 block">
            SOLUÇÕES COMPLETAS
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Serviços Corporativos de Conectividade
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto">
            Oferecemos soluções personalizadas de dados, internet dedicada e telefonia IP para empresas de todos os tamanhos em setores críticos.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const bgColor = serviceColors[service.title] || 'bg-[#0079be]';
            return (
              <Card
                key={index}
                className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 hover:shadow-2xl hover:-translate-y-2 overflow-hidden group"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                {/* Colored Top Bar */}
                <div className={`h-2 ${bgColor}`}></div>
                
                <CardContent className="p-8">
                  {/* Service Icon/Badge */}
                  <div className="mb-6">
                    <div className={`inline-flex items-center justify-center w-16 h-16 ${bgColor} rounded-xl shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                      <span className="text-2xl font-bold text-white">
                        {service.title.charAt(0)}
                      </span>
                    </div>
                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Features List */}
                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  {/* CTA Button */}
                  <Button
                    variant="outline"
                    className="w-full group/btn hover:bg-[#0079be] hover:text-white hover:border-[#0079be] transition-all duration-300"
                  >
                    <span>Saber Mais</span>
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform duration-300" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;